/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  OTELAttribute,
  OTELAttribute$Outbound,
  OTELAttribute$outboundSchema,
} from "./otelattribute.js";
import {
  OTELLogBody,
  OTELLogBody$Outbound,
  OTELLogBody$outboundSchema,
} from "./otellogbody.js";

/**
 * Individual OTEL log record
 */
export type OTELLogRecord = {
  /**
   * Log attributes
   */
  attributes?: Array<OTELAttribute> | undefined;
  /**
   * OTEL log body
   */
  body?: OTELLogBody | undefined;
  /**
   * Number of dropped attributes
   */
  droppedAttributesCount?: number | undefined;
  /**
   * Observed timestamp in nanoseconds
   */
  observedTimeUnixNano?: string | undefined;
  /**
   * Span ID
   */
  spanId?: string | undefined;
  /**
   * Timestamp in nanoseconds since Unix epoch
   */
  timeUnixNano?: string | undefined;
  /**
   * Trace ID
   */
  traceId?: string | undefined;
};

/** @internal */
export type OTELLogRecord$Outbound = {
  attributes?: Array<OTELAttribute$Outbound> | undefined;
  body?: OTELLogBody$Outbound | undefined;
  droppedAttributesCount?: number | undefined;
  observedTimeUnixNano?: string | undefined;
  spanId?: string | undefined;
  timeUnixNano?: string | undefined;
  traceId?: string | undefined;
};

/** @internal */
export const OTELLogRecord$outboundSchema: z.ZodMiniType<
  OTELLogRecord$Outbound,
  OTELLogRecord
> = z.object({
  attributes: z.optional(z.array(OTELAttribute$outboundSchema)),
  body: z.optional(OTELLogBody$outboundSchema),
  droppedAttributesCount: z.optional(z.int()),
  observedTimeUnixNano: z.optional(z.string()),
  spanId: z.optional(z.string()),
  timeUnixNano: z.optional(z.string()),
  traceId: z.optional(z.string()),
});

export function otelLogRecordToJSON(otelLogRecord: OTELLogRecord): string {
  return JSON.stringify(OTELLogRecord$outboundSchema.parse(otelLogRecord));
}
